var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pl-2 pr-2"},[(_vm.text)?_c('v-col',{attrs:{"col":"12"}},_vm._l((_vm.text),function(error,index){return _c('div',{key:index},[_c('v-alert',{staticClass:"red",attrs:{"dismissible":"","type":"error","value":true},on:{"input":_vm.onClose}},[_vm._v(" "+_vm._s(error)+" ")])],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }